// Stock images for SEO pages — SEO-optimized alt text with target keywords
// Alt text follows: [primary keyword] + [descriptive context] pattern

const IMAGES = {
  interpreting: [
    { url: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800&h=500&fit=crop', alt: 'Professional interpreter providing over-the-phone interpreting services to a client' },
    { url: 'https://images.pexels.com/photos/8867424/pexels-photo-8867424.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Interpreter services team delivering real-time multilingual language support' },
    { url: 'https://images.pexels.com/photos/5467595/pexels-photo-5467595.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Phone interpreting specialists providing 24/7 over-the-phone interpreter services' },
  ],
  healthcare: [
    { url: 'https://images.unsplash.com/photo-1758691462126-2ee47c8bf9e7?w=800&h=500&fit=crop', alt: 'Medical interpreter assisting healthcare provider with patient communication in hospital' },
    { url: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800&h=500&fit=crop', alt: 'HIPAA-compliant healthcare interpreter services in a clinical setting' },
    { url: 'https://images.unsplash.com/photo-1516549655169-df83a0774514?w=800&h=500&fit=crop', alt: 'Doctor using medical interpreter services during patient consultation' },
  ],
  legal: [
    { url: 'https://images.pexels.com/photos/7876314/pexels-photo-7876314.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Court interpreter providing professional legal interpreting services during proceeding' },
    { url: 'https://images.pexels.com/photos/7841457/pexels-photo-7841457.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Legal interpreter services for attorney-client conference at law office' },
    { url: 'https://images.unsplash.com/photo-1589578527966-fdac0f44566c?w=800&h=500&fit=crop', alt: 'Scales of justice representing professional court interpreter services for legal proceedings' },
  ],
  video: [
    { url: 'https://images.pexels.com/photos/4226122/pexels-photo-4226122.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Video remote interpreting session on laptop showing VRI interpreter services' },
    { url: 'https://images.unsplash.com/photo-1766074903112-79661da9ab45?w=800&h=500&fit=crop', alt: 'Video interpreting conference call with multilingual participants and interpreter' },
    { url: 'https://images.pexels.com/photos/6937870/pexels-photo-6937870.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Business professional using secure video remote interpreter services on device' },
  ],
  corporate: [
    { url: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=500&fit=crop', alt: 'Corporate interpreter services supporting multilingual team meeting in boardroom' },
    { url: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&h=500&fit=crop', alt: 'Business interpreter facilitating international conference room discussion' },
    { url: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=500&fit=crop', alt: 'International business team using corporate interpreter services for cross-language collaboration' },
  ],
  government: [
    { url: 'https://images.unsplash.com/photo-1541872703-74c5e44368f9?w=800&h=500&fit=crop', alt: 'Government interpreter services at federal building for public sector language access' },
    { url: 'https://images.unsplash.com/photo-1577495508048-b635879837f1?w=800&h=500&fit=crop', alt: 'Multilingual community members accessing government services with interpreter support' },
    { url: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=800&h=500&fit=crop', alt: 'Government agency staff providing Title VI compliant interpreter services to constituents' },
  ],
  callCenter: [
    { url: 'https://images.unsplash.com/photo-1637855194883-c80ea95e3448?w=800&h=500&fit=crop', alt: 'Professional interpreter at desk with headset providing over-the-phone language services' },
    { url: 'https://images.pexels.com/photos/7709278/pexels-photo-7709278.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Multilingual call center providing 24/7 phone interpreter services in 250 languages' },
    { url: 'https://images.unsplash.com/photo-1766066014237-00645c74e9c6?w=800&h=500&fit=crop', alt: 'Professional phone interpreter at workstation delivering real-time language support' },
  ],
  teamwork: [
    { url: 'https://images.unsplash.com/photo-1758691737158-18ffa31c0a46?w=800&h=500&fit=crop', alt: 'Diverse interpreter services team collaborating on multilingual project delivery' },
    { url: 'https://images.unsplash.com/photo-1758873271761-6cfe9b4f000c?w=800&h=500&fit=crop', alt: 'Language services team reviewing interpreter quality metrics and reports' },
    { url: 'https://images.pexels.com/photos/7868979/pexels-photo-7868979.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Interpreter services management team in modern language services office' },
  ],
  technology: [
    { url: 'https://images.unsplash.com/photo-1553775282-20af80779df7?w=800&h=500&fit=crop', alt: 'Interpreter services technology platform with headset and laptop for remote interpreting' },
    { url: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&h=500&fit=crop', alt: 'Language services technology office powering AI-enhanced interpreter platform' },
    { url: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&h=500&fit=crop', alt: 'Engineering team building interpreter services infrastructure and VRI platform' },
  ],
  globe: [
    { url: 'https://images.unsplash.com/photo-1758242867435-a99042434f71?w=800&h=500&fit=crop', alt: 'World map showing global interpreter services coverage across US Canada UK and Australia' },
    { url: 'https://images.unsplash.com/photo-1521295121783-8a321d551ad2?w=800&h=500&fit=crop', alt: 'Diverse hands representing multilingual interpreter services community worldwide' },
    { url: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=500&fit=crop', alt: 'Multicultural professionals using interpreter services for cross-cultural communication' },
  ],
  onsite: [
    { url: 'https://images.unsplash.com/photo-1558403194-611308249627?w=800&h=500&fit=crop', alt: 'On-site interpreter facilitating in-person interpreting at medical facility' },
    { url: 'https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=800&h=500&fit=crop', alt: 'Conference interpreter providing simultaneous interpreting at live corporate event' },
    { url: 'https://images.pexels.com/photos/8124232/pexels-photo-8124232.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Professional on-site interpreters prepared for scheduled interpreting assignment' },
  ],
  howItWorks: { url: 'https://images.pexels.com/photos/7709254/pexels-photo-7709254.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Professional interpreter with headset providing real-time language services at office workstation' },
};

// Deterministic hash for selecting images
function imgHash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = ((h << 5) - h + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

// Get images for city pages (5 images)
export function getCityImages(citySlug) {
  const h = imgHash(citySlug);
  const sets = [IMAGES.interpreting, IMAGES.healthcare, IMAGES.legal, IMAGES.video, IMAGES.corporate, IMAGES.callCenter, IMAGES.teamwork];
  return [
    sets[h % sets.length][0],
    sets[(h + 1) % sets.length][1],
    sets[(h + 2) % sets.length][2 % 3],
    IMAGES.howItWorks,
    IMAGES.globe[h % 3],
  ];
}

// Get images for language pages (5 images)
export function getLanguageImages(langSlug) {
  const h = imgHash(langSlug);
  const sets = [IMAGES.interpreting, IMAGES.healthcare, IMAGES.legal, IMAGES.video, IMAGES.corporate, IMAGES.callCenter, IMAGES.teamwork];
  return [
    sets[h % sets.length][0],
    sets[(h + 2) % sets.length][0],
    sets[(h + 3) % sets.length][1],
    IMAGES.howItWorks,
    IMAGES.technology[h % 3],
  ];
}

// Get images for hybrid pages (5 images)
export function getHybridImages(langSlug, citySlug) {
  const h = imgHash(langSlug + citySlug);
  const sets = [IMAGES.interpreting, IMAGES.healthcare, IMAGES.legal, IMAGES.video, IMAGES.corporate, IMAGES.callCenter, IMAGES.teamwork];
  return [
    sets[h % sets.length][0],
    sets[(h + 1) % sets.length][1],
    sets[(h + 2) % sets.length][2 % 3],
    IMAGES.howItWorks,
    IMAGES.callCenter[h % 3],
  ];
}

// Get images for service pages (5 images per service type)
export function getServiceImages(serviceSlug) {
  if (serviceSlug === 'phone-interpreting') return [IMAGES.callCenter[0], IMAGES.callCenter[1], IMAGES.callCenter[2], IMAGES.howItWorks, IMAGES.technology[0]];
  if (serviceSlug === 'video-interpreting') return [IMAGES.video[0], IMAGES.video[1], IMAGES.video[2], IMAGES.howItWorks, IMAGES.healthcare[0]];
  if (serviceSlug === 'ai-interpreting') return [
    { url: 'https://images.unsplash.com/photo-1770233621425-5d9ee7a0a700?w=800&h=500&fit=crop', alt: 'AI-powered interpreting technology concept' },
    { url: 'https://images.unsplash.com/photo-1758598306535-93877d73892d?w=800&h=500&fit=crop', alt: 'Professional using AI interpreter with headset and laptop' },
    { url: 'https://images.unsplash.com/photo-1758598305011-dcb2bef42363?w=800&h=500&fit=crop', alt: 'Person connected to AI interpreting session at desk' },
    IMAGES.howItWorks,
    { url: 'https://images.unsplash.com/photo-1758874383530-98fa5960bd76?w=800&h=500&fit=crop', alt: 'AI interpreter technology enabling multilingual communication' },
  ];
  return [IMAGES.onsite[0], IMAGES.onsite[1], IMAGES.onsite[2], IMAGES.howItWorks, IMAGES.legal[0]];
}

// Get images for industry pages (5 images per industry)
export function getIndustryImages(industrySlug) {
  if (industrySlug === 'healthcare-interpreting-services') return [IMAGES.healthcare[0], IMAGES.healthcare[1], IMAGES.healthcare[2], IMAGES.howItWorks, IMAGES.callCenter[0]];
  if (industrySlug === 'legal-interpreting-services') return [IMAGES.legal[0], IMAGES.legal[1], IMAGES.legal[2], IMAGES.howItWorks, IMAGES.corporate[0]];
  if (industrySlug === 'government-interpreting-services') return [IMAGES.government[0], IMAGES.government[1], IMAGES.government[2], IMAGES.howItWorks, IMAGES.globe[0]];
  if (industrySlug === 'education-interpreting-services') return [
    { url: 'https://images.unsplash.com/photo-1758270704925-fa59d93119c1?w=800&h=500&fit=crop', alt: 'Teacher lecturing in a diverse classroom' },
    { url: 'https://images.unsplash.com/photo-1758270704080-e3556e6794a7?w=800&h=500&fit=crop', alt: 'Diverse students learning in modern classroom' },
    { url: 'https://images.pexels.com/photos/8617940/pexels-photo-8617940.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Students attentively listening to teacher in classroom' },
    IMAGES.howItWorks,
    { url: 'https://images.unsplash.com/photo-1758270705087-76e81a5117bd?w=800&h=500&fit=crop', alt: 'Professor teaching in a lecture hall setting' },
  ];
  if (industrySlug === 'policing-interpreting-services') return [
    { url: 'https://images.unsplash.com/flagged/photo-1572047449432-c0d2dc1181bb?w=800&h=500&fit=crop', alt: 'Police officer in formal uniform' },
    { url: 'https://images.pexels.com/photos/7714863/pexels-photo-7714863.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Police officers interacting with community members' },
    { url: 'https://images.pexels.com/photos/7714748/pexels-photo-7714748.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Police officers working together in the community' },
    IMAGES.howItWorks,
    { url: 'https://images.unsplash.com/photo-1570865902386-c315b9471971?w=800&h=500&fit=crop', alt: 'Community policing and public safety' },
  ];
  if (industrySlug === 'immigration-interpreting-services') return [
    { url: 'https://images.pexels.com/photos/17209785/pexels-photo-17209785.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Government building for immigration services' },
    { url: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&h=500&fit=crop', alt: 'Professional consultation meeting' },
    { url: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=500&fit=crop', alt: 'Documentation and paperwork processing' },
    IMAGES.howItWorks,
    { url: 'https://images.pexels.com/photos/5945799/pexels-photo-5945799.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Diverse professionals in meeting' },
  ];
  if (industrySlug === 'corrections-interpreting-services') return [
    { url: 'https://images.unsplash.com/photo-1589578228447-e1a4e481c6c8?w=800&h=500&fit=crop', alt: 'Secure facility building exterior' },
    { url: 'https://images.pexels.com/photos/17209785/pexels-photo-17209785.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Government institutional building' },
    { url: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&h=500&fit=crop', alt: 'Administrative meeting and consultation' },
    IMAGES.howItWorks,
    { url: 'https://images.pexels.com/photos/7868979/pexels-photo-7868979.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Professional staff in institutional setting' },
  ];
  if (industrySlug === 'call-centers-interpreting-services') return [
    { url: 'https://images.unsplash.com/photo-1560264280-88b68371db39?w=800&h=500&fit=crop', alt: 'Call center agents with headsets' },
    { url: 'https://images.unsplash.com/photo-1556745753-b2904692b3cd?w=800&h=500&fit=crop', alt: 'Customer service representative on phone' },
    { url: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&h=500&fit=crop', alt: 'Modern call center operations' },
    IMAGES.howItWorks,
    { url: 'https://images.pexels.com/photos/5945799/pexels-photo-5945799.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop', alt: 'Multilingual customer support environment' },
  ];
  return [IMAGES.corporate[0], IMAGES.corporate[1], IMAGES.corporate[2], IMAGES.howItWorks, IMAGES.video[1]];
}

// Get images for about page (5 images)
export function getAboutImages() {
  return [IMAGES.teamwork[0], IMAGES.globe[2], IMAGES.technology[1], IMAGES.globe[0], IMAGES.onsite[2]];
}

// Get images for contact page (4 images)
export function getContactImages() {
  return [IMAGES.callCenter[0], IMAGES.teamwork[1], IMAGES.globe[1], IMAGES.technology[0]];
}

// Get images for service-location pages (4 images)
export function getServiceLocationImages(serviceSlug, citySlug) {
  const h = imgHash(serviceSlug + citySlug);
  const sets = [IMAGES.interpreting, IMAGES.healthcare, IMAGES.callCenter, IMAGES.video, IMAGES.onsite, IMAGES.corporate];
  return [
    sets[h % sets.length][0],
    sets[(h + 1) % sets.length][1],
    sets[(h + 2) % sets.length][2 % 3],
    IMAGES.howItWorks,
  ];
}

// Get images for home page (5 images)
export function getHomeImages() {
  return [
    IMAGES.interpreting[0],
    IMAGES.callCenter[0],
    IMAGES.healthcare[0],
    IMAGES.corporate[1],
    IMAGES.globe[0],
  ];
}

export default IMAGES;
